
function loadUtmRecords() {
  const urlParams = new URLSearchParams(window.location.search);
  const params = {
    utm_campaign: urlParams.get("utm_campaign") ?? null,
    utm_content: urlParams.get("utm_content") ?? null,
    utm_medium: urlParams.get("utm_medium") ?? null,
    utm_source: urlParams.get("utm_source") ?? null,
    utm_term: urlParams.get("utm_term") ?? null,
  };


    const hasValidUtmParam = Object.values(params).some(value => value !== null);

  if (hasValidUtmParam) {
    sessionStorage.setItem("utm_keys", JSON.stringify(params));
    console.log('UTM parameters saved:', params);
  } else {
    console.log('No valid UTM parameters to save.');
  }
}

loadUtmRecords()